import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-right', 'ArrowDownRight', [["path",{"d":"m6.5 6.5 11 11m0-9v9h-9","key":"svg-0"}]]);